import React from 'react';
import { HeaderGeneral as HeaderGeneralBase } from '@/components/DybrComponents/HeaderGeneral';
import { NavTab } from '@/components/DybrComponents/NavTab';
import { ServiceBackground } from '@/components/DybrComponents/ServiceBackground';
import TabsContainer from '@/components/DybrComponents/TabsContainer';
import { DiscussionsPage } from './DiscussionsPage';
import type { FilterMode } from './types';

// HeaderGeneral is a JS styled-component; cast to accept its custom paddingBottom prop
const HeaderGeneral = HeaderGeneralBase as React.ComponentType<
  React.HTMLAttributes<HTMLDivElement> & { paddingBottom?: string }
>;

const LABELS = {
  title: 'обсуждения',
  tabDiscussions: 'Дискуссии',
  tabComments: 'Комментарии',
  tabMentions: 'Упоминания'
};

// TODO: backend doesn't support filters[notification_type] yet, so the tabs would all show
// the same unfiltered list. Re-enable once filtering is supported.
const SHOW_TABS = false;

interface Props {
  filterMode: FilterMode;
}

export function DiscussionsScene({ filterMode }: Props) {
  return (
    <ServiceBackground>
      <HeaderGeneral paddingBottom="45px">
        <h1>{LABELS.title}</h1>
        {SHOW_TABS && (
          <TabsContainer>
            <NavTab to="/discussions" end>
              {LABELS.tabDiscussions}
            </NavTab>
            <NavTab to="/comments">{LABELS.tabComments}</NavTab>
            <NavTab to="/mentions">{LABELS.tabMentions}</NavTab>
          </TabsContainer>
        )}
      </HeaderGeneral>

      <DiscussionsPage filterMode={filterMode} />
    </ServiceBackground>
  );
}
